import { flushSync } from 'react-dom';

const pending = new Set<() => void>();
export function registerInputDraft(commit: () => void): () => void {
  pending.add(commit);
  return () => { pending.delete(commit); };
}
// Called at interaction boundaries, not during render or effect cleanup.
export function flushInputDrafts(): void {
  if (!pending.size) return;
  flushSync(() => { for (const commit of [...pending]) commit(); });
}
export function normalizeNumericDraft(text: string, value: number, min?: number, max?: number, step = 1): number {
  const parsed = text.trim() ? Number(text) : min ?? 0;
  if (!Number.isFinite(parsed)) return value;
  const finite = Math.max(min ?? -Infinity, Math.min(max ?? Infinity, parsed));
  return step === 1 ? Math.max(min ?? -Infinity, Math.min(max ?? Infinity, Math.round(finite))) : finite;
}
